// extracted by mini-css-extract-plugin
export default {"cells":"uXrWS","cells__image-wrapper":"LENyK","cells__image-wrapper_isImage":"q6r20","cells__image":"rRLG","cells__text":"AWmgM"};